var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v("הוספת ספר לבנק"),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogReportPaid__Component__Loading" },
          [
            _c(
              "b-field",
              { attrs: { label: "הזן כותרת לספר" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "title", $$v)
                    },
                    expression: "model.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "הזן תת כותרת לספר" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.subtitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "subtitle", $$v)
                    },
                    expression: "model.subtitle",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "הזן יוצר לספר" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.author,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "author", $$v)
                    },
                    expression: "model.author",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "הזן קישור לספר" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.link,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "link", $$v)
                    },
                    expression: "model.link",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "הזן תמונה לספר" } },
              [
                _c("b-input", {
                  model: {
                    value: _vm.model.imageUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "imageUrl", $$v)
                    },
                    expression: "model.imageUrl",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }